/* @flow */
import { dispatcher } from 'lib/Dispatcher';
import { ErrorMessages } from 'constants/ErrorConstants';
import { ReduceStore } from 'flux/utils';

// Note: Flux stores are now a DEPRECATED pattern. See docs/GraphQL.md
class ErrorStore extends ReduceStore {
  getInitialState() {
    return {
      title: (null: ?string),
      body: (null: ?string),
    };
  }

  getTitle() {
    return this.getState().title;
  }

  getBody() {
    return this.getState().body;
  }

  reduce(state, action) {
    const error = ErrorMessages[action.type];

    if (error) {
      const { title, body } = error[action.context || 'DEFAULT'];
      return Object.assign({}, state, { title, body });
    } else {
      return state;
    }
  }
}

export default new ErrorStore(dispatcher);
